import { useState } from "react";
import { Menu, X, Ruler } from "lucide-react";
import { scrollToId } from "../../lib/lenis";
import SpecsModal from "./SpecsModal";

const LINKS = [
  { id: "pu", label: "PU", num: "01" },
  { id: "solidwood", label: "Solidwood", num: "02" },
  { id: "membrane", label: "Membrane", num: "03" },
  { id: "laminate", label: "Laminate", num: "04" },
  { id: "ceramic", label: "Ceramic", num: "05" },
  { id: "acrylic", label: "Acrylic", num: "06" },
  { id: "glass", label: "Glass", num: "07" },
  { id: "wardrobe", label: "Wardrobes", num: "08" }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [specs, setSpecs] = useState(false);

  return (
    <>
      <header
        data-testid="site-header"
        className="fixed top-0 inset-x-0 z-50 bg-ink/95 backdrop-blur-xl border-b border-bone/10"
      >
        <div className="max-w-[1600px] mx-auto flex items-center justify-between px-5 sm:px-8 lg:px-12 h-[72px]">
          <button
            data-testid="brand-home-btn"
            onClick={() => scrollToId("top")}
            className="flex items-center gap-3 group text-left"
          >
            <img
              src="/images/logo-white.png"
              alt="Innovation Modular System logo"
              className="h-9 w-auto"
            />
          </button>

          <nav className="hidden lg:flex items-center gap-5" data-testid="desktop-nav">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="group flex items-baseline gap-1.5 text-sm text-bone/70 hover:text-bone transition-colors"
              >
                <span className="font-mono text-[10px] text-beiged group-hover:text-bone transition-colors">{l.num}</span>
                <span className="relative">
                  {l.label}
                  <span className="absolute -bottom-1 left-0 h-px w-0 bg-bone transition-all duration-500 group-hover:w-full" />
                </span>
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="design-limits-btn"
              onClick={() => setSpecs(true)}
              className="hidden sm:flex items-center gap-2 border border-bone/30 rounded-full px-5 py-2.5 text-xs font-mono uppercase tracking-[0.2em] text-bone hover:bg-bone hover:text-ink transition-colors duration-300"
            >
              <Ruler size={13} strokeWidth={1.5} />
              Design Limits
            </button>
            <button
              data-testid="mobile-menu-btn"
              onClick={() => setOpen(!open)}
              className="lg:hidden p-2 text-bone"
              aria-label="Menu"
            >
              {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden bg-ink border-t border-bone/10 px-6 py-6 space-y-4" data-testid="mobile-menu">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={() => { setOpen(false); scrollToId(l.id); }}
                className="flex items-baseline gap-3 w-full text-left font-serif text-2xl text-bone"
              >
                <span className="font-mono text-[10px] text-beiged">{l.num}</span>
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-design-limits-btn"
              onClick={() => { setOpen(false); setSpecs(true); }}
              className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-bone/60 pt-2"
            >
              <Ruler size={13} strokeWidth={1.5} /> Design Limits
            </button>
          </div>
        )}
      </header>
      <SpecsModal open={specs} onClose={() => setSpecs(false)} />
    </>
  );
}
